module.exports = __webpack_public_path__ + "img/pat_01.1b387293.jpg";